import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-flip-counter',
  templateUrl: './flip-counter.component.html',
  styleUrls: ['./flip-counter.component.scss']
})
export class FlipCounterComponent implements OnInit {
  @Input() value: any;
  constructor() { }

  ngOnInit(): void {
  }

  get covertVaccCounterToArr() {
    let myFunc = (num: any) => Number(num);
    return Array.from(String(this.value), myFunc);

  }

}
